<template>
    <div class="yq-section-config" v-if="sectionType">
        <div class="yq-section-config-head">
            <div class="yq-section-config-name">栏目配置</div>
            <div class="yq-section-config-toolbar">
                <el-link @click="saveConfig(true)" :underline="false" icon="el-icon-check">保存</el-link>
                <el-link @click="returnBack" :underline="false" icon="el-icon-back">返回</el-link>
            </div>
        </div>
        <div class="yq-section-config-content">
            <div class="yq-section-config-left">
                <component ref="form" :is="sectionType.config" :id="id"></component>
            </div>
            <div class="yq-section-config-right">
                <div class="yq-section-config-right-head">
                    <span>时间范围：</span>
                    <time-interval-picker v-model="timeInterval"></time-interval-picker>
                    <el-link @click="refresh" :underline="false" icon="el-icon-refresh">刷新</el-link>
                </div>
                <div class="yq-section-config-right-body">
                    <component :is="sectionType.component" :id="id" :show-config-ui="false"
                               :refresh-id="refreshId" :time-interval="timeInterval"></component>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import sectionService from '../../service/section'
    import sectionTypeService from '../../service/section-type'
    import TimeIntervalPicker from '../common/DateIntervalPicker'

    export default {
        name: "SectionConfig",
        components: {TimeIntervalPicker},
        props: {
            id: Number
        },
        data() {
            return {
                sectionType: null,
                refreshId: 0,
                timeInterval: 'P3M'
            }
        },
        created() {
            this.init()
        },
        watch: {
            id() {
                this.init()
            }
        },
        methods: {
            async init() {
                const response = await sectionService.getSection(this.id)
                this.sectionType = sectionTypeService.getSectionType(response.data.type)
            },
            async saveConfig(refreshPreview) {
                try {
                    await this.$refs.form.save()
                    if (refreshPreview) {
                        this.refreshId++
                    }
                } catch (e) {
                    this.$message({
                        type: 'error',
                        message: '保存失败!'
                    })
                }
            },
            async returnBack() {
                if (this.$refs.form.isDirty()) {
                    let confirmed
                    try {
                        await this.$confirm('页面配置已修改, 是否保存?', '提示', {
                            confirmButtonText: '保存',
                            cancelButtonText: '不保存',
                            type: 'warning'
                        })
                        confirmed = true
                    } catch (e) {
                        confirmed = false
                    }
                    if (confirmed) {
                        await this.saveConfig(false)
                    }
                }
                this.$emit('close')
            },
            refresh() {
                this.refreshId++
            }
        }
    }
</script>

<style scoped>

</style>
